import React, { useEffect, useMemo, useRef, useState } from "react";
import CommonInput from "../../../CommonMethhods/CommonInput";
import { Lead_Creation } from "../../../Configuration/API_URL";
import axios from "axios";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  mobileVal,
  onlyNumber,
  splitDateNewSlash,
} from "../../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import CommonSelect from "../../../CommonMethhods/CommonSelect";
import { useResumeContext } from "../../../CommonMethhods/Context";
import { useClientContext } from "../../../context/ClientContext";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Modal } from "react-bootstrap";
import questionImg from "../../../asset/images/questionIcon.svg";


function NomineeDetails(props) {
  const IndiMobileNo = localStorage.getItem("IndiMobileNo");
  const storeToken = localStorage.getItem("ssoToken");
  const resumeVal = props?.resumeVal;
  const showNominee = props?.showNominee;
  const prevLengthRef = useRef;
  const relation = props.relation;
  const { resumeHandle } = useResumeContext();
  const justSubmitted = useRef(false);
  const [pincodeVal, setPincodeVal] = useState([]);
  const [sameAsAbove, setSameAsAbove] = useState([]);
  const [activeIndex, setActiveIndex] = useState("");
  const [totalPercentage, setTotalPercentage] = useState(0);
  const [addNominee, setAddNominee] = useState(false);
  const [emptyFields, setEmptyFields] = useState(false);
  const [totalPerVal, setTotalPerVal] = useState(0);
  const [loader, setLoader] = useState(false);
  const [addFlag, setAddFlag] = useState(false);
  const [emptyIndexes, setEmptyIndexes] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  const [nomState, setNomState] = useState([]);
  const activeTab = props?.activeTab;
  const [isFormModifiedAfterSave, setIsFormModifiedAfterSave] = useState(false);
  const { selectedClient, shouldPrefill } = useClientContext();
  const [isDetailsSaved, setIsDetailsSaved] = useState(false);
  const isWatchingAfterSave = useRef(false);
  const [delModal, setDelModal] = useState(false);
  const [nomId, setNomId] = useState(null);
  const [nomIndex, setNomIndex] = useState(null);
  const [deleteLoader, setDeleteLoader] = useState(false);

  const errorSchema = Yup.object().shape({
    nominees: Yup.array()
      .of(
        Yup.object().shape({
          nameValid: Yup.string()
            .required("Full Name is required")
            .test(
              "not-same-as-client",
              "Nominee name must not be same as client name",
              function (value) {
                const { path, createError } = this;
                const clientName = resumeVal?.basicDetails?.fullName
                  ?.trim()
                  ?.toLowerCase();
                return value?.trim()?.toLowerCase() !== clientName
                  ? true
                  : createError({
                    path,
                    message: "Nominee name must not be same as client name",
                  });
              }
            ),
          mobileValid: Yup.string()
            .required("Mobile Number is required")
            .matches(/^[6-9]{1}[0-9]{9}$/, "Enter Valid Mobile No"),
          emailValid: Yup.string()
            .required("Email Id is required")
            .matches(
              /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
              "Please enter a valid email ID"
            )
            .test('no-special-char-start', 'The local part of the email cannot start with a special character.', (value) => {
              if (!value) return false;
              const atPos = value.indexOf('@');
              if (atPos > 0) {
                const localPart = value.substring(0, atPos);
                if (/^[.!#$%&'*+/=?^_`{|}~-]/.test(localPart[0])) {
                  return false;
                }
              }
              return true;
            })
            .test('dot-before-at', 'A dot (.) or special character cannot be immediately before the @ symbol.', (value) => {
              if (!value) return false;
              const atPos = value.indexOf('@');
              if (atPos > 0) {
                const charBeforeAt = value[atPos - 1];
                return /^[a-zA-Z0-9]$/.test(charBeforeAt);
              }
              return true;
            })
            .test('no-digit-after-at', 'The domain part cannot contain digits after the @ symbol.', (value) => {
              if (!value) return false;
              const atPos = value.indexOf('@');
              if (atPos > -1) {
                const domainPart = value.substring(atPos + 1);  // The part after '@'
                // Ensure that no digits exist in the domain part
                if (/\d/.test(domainPart)) {  // Check if there are digits anywhere after '@'
                  return false;
                }
              }
              return true;
            })
            .test('no-special-char-after-at', 'The domain part cannot contain special characters after the @ symbol.', (value) => {
              if (!value) return false;
              const atPos = value.indexOf('@');
              if (atPos > -1) {
                const domainPart = value.substring(atPos + 1);  // The part after '@'
                // Ensure no special characters except for '.' in the domain part
                if (/[^a-zA-Z0-9.]/.test(domainPart)) {
                  return false;
                }
              }
              return true;
            })
            .test('dot-required-after-at', 'The domain part must contain at least one dot (.) after the @ symbol.', (value) => {
              if (!value) return false;
              const atPos = value.indexOf('@');
              if (atPos > -1) {
                const domainPart = value.substring(atPos + 1); // The part after '@'
                if (!domainPart.includes('.')) {  // Check if the domain part contains a dot (.)
                  return false;
                }
              }
              return true;
            }),
          // dobValid: Yup.string()
          //   .required("DOB is required")
          //   .test(
          //     "is-valid-date",
          //     "Please enter a valid calendar date",
          //     function (value) {
          //       if (!value) return false;
          //       const [year, month, day] = value.split("-").map(Number);
          //       const date = new Date(year, month - 1, day);
          //       const isValid =
          //         date &&
          //         date.getFullYear() === year &&
          //         date.getMonth() === month - 1 &&
          //         date.getDate() === day;

          //       if (!isValid) return false;
          //       const today = new Date();
          //       today.setHours(0, 0, 0, 0);
          //       return date <= today;
          //     }
          //   ),

          //         dobValid: Yup.string()
          // .required("DOB is required")
          // .test("is-valid-date", "Please enter a valid calendar date", function (value) {
          //   if (!value) return this.createError({ message: "DOB is required" });

          //   const [year, month, day] = value.split("-").map(Number);
          //   const date = new Date(year, month - 1, day);

          //   // check exact match (to block 31-02 type cases)
          //   const isValid =
          //     date &&
          //     date.getFullYear() === year &&
          //     date.getMonth() === month - 1 &&
          //     date.getDate() === day;

          //   if (!isValid) {
          //     return this.createError({
          //       message: "Please enter a valid calendar date",
          //     });
          //   }

          //   // block future dates
          //   const today = new Date();
          //   today.setHours(0, 0, 0, 0);
          //   if (date > today) {
          //     return this.createError({
          //       message: "Date of Birth cannot be a future date",
          //     });
          //   }

          //   return true;
          // }),

          dobValid: Yup.date()
            .typeError("Please enter a valid calendar date")
            .required("DOB is required")
            .max(new Date(), "Date cannot be greater than today"),
          guardianName: Yup.string().when("dobValid", {
            is: (dob) => isUnder18(dob),
            then: Yup.string().required("Guardian's Full Name is required")
              .test(
                "not-same-as-nominee",
                "Guardian name must not be same as Nominee name",
                function (value) {
                  const nomineeName = this.parent?.nameValid;
                  if (!value || !nomineeName) return true;
                  return value.trim().toLowerCase() !== nomineeName.trim().toLowerCase();
                }
              ),
            otherwise: Yup.string().notRequired(),
          }),
          guardianDob: Yup.string().when("dobValid", {
            is: (dob) => isUnder18(dob),
            then: Yup.string()
              .required("DOB is required")
              // .matches(/^\d{2}\/\d{2}\/\d{4}$/, "Enter valid DD/MM/YYYY")
              .test(
                "is-18+",
                "Guardian must be at least 18 years old",
                function (value) {
                  if (!value) return false;
                  const [year, month, day] = value.split("-").map(Number);
                  const dob = new Date(year, month - 1, day);
                  const today = new Date();
                  if (isNaN(dob.getTime())) return false;

                  let age = today.getFullYear() - dob.getFullYear();
                  const m = today.getMonth() - dob.getMonth();
                  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
                    age--;
                  }
                  return age >= 18;
                }
              ),
            otherwise: Yup.string().notRequired(),
          }),
          guardianRel: Yup.string().when("dobValid", {
            is: (dob) => isUnder18(dob),
            then: Yup.string().required("Relationship is required"),
            otherwise: Yup.string().notRequired(),
          }),
          guardianAadhar: Yup.string().when("dobValid", {
            is: (dob) => isUnder18(dob),
            then: Yup.string()
              .required("Guardian's Aadhaar Number is required")
              .matches(/^[*]{8}[0-9]{4}$/, "Enter last 4 digits of Aadhaar")
              .test(
                "guardian-aadhar-different",
                "Guardian Aadhaar and Nominee Aadhaar cannot be the same",
                function (value) {
                  const { aadharValid } = this.parent;
                  return value !== aadharValid;
                }
              ),
            otherwise: Yup.string().notRequired(),
          }),
          nomAddress1: Yup.string().required("Address is required"),
          nomAddress2: Yup.string(),
          pinCodeValid: Yup.string().required("Pincode is required"),
          cityValid: Yup.string().test(
            "cityValid",
            "City is required",
            function (value) {
              const { path, createError, options } = this;
              const nomCity = options.context?.nomCity;
            //   return cityOptions?.length > 0 || value
            //     ? true
            //     : createError({ path, message: "City is required" });
            // }
            return value?.trim()?.length > 0 || nomCity?.trim()?.length > 0
      ? true
      : createError({ path, message: "City is required" });
  }
          ),
          stateValid: Yup.string().test(
            "stateValid",
            "State is required",
            function (value) {
              const { path, createError, options } = this;
              const { nomState } = options.context || {};
              const fieldValue = value?.toString().trim();
              const hasValue = !!fieldValue || !!nomState?.toString().trim();
              return hasValue || createError({ path });
            }
          ),
          nomineeRelValid: Yup.string().required(
            "Relationship is required"
          ),
          percentageValid: Yup.string().required("Percentage is required"),
          aadharValid: Yup.string()
            .required("Aadhaar Number is required")
            .matches(/^\*{8}\d{4}$/, "Enter last 4 digits of Aadhaar"),
        })
      )
      .max(3, "You can only add up to 3 nominees")
      .test(
        "totalPercentage",
        "Total percentage cannot exceed 100",
        function (nominees) {
          const total = nominees?.reduce((sum, nom) => {
            const val = parseFloat(nom?.percentageValid);
            return sum + (isNaN(val) ? 0 : val);
          }, 0);
          return total <= 100;
        }
      )
      .test("no-duplicate-name-aadhar", null, function (nominees = []) {
        const nameMap = new Map();
        const aadharMap = new Map();

        for (let i = 0; i < nominees.length; i++) {
          const name = nominees[i]?.nameValid?.toLowerCase().trim();
          const aadhar = nominees[i]?.aadharValid;

          if (name && nameMap.has(name)) {
            return this.createError({
              path: `nominees[${i}].nameValid`,
              message: "Nominee names can not be same",
            });
          }
          if (aadhar && aadharMap.has(aadhar)) {
            return this.createError({
              path: `nominees[${i}].aadharValid`,
              message: "Nominee Aadhar no can not be same",
            });
          }

          if (name) nameMap.set(name, true);
          if (aadhar) aadharMap.set(aadhar, true);
        }

        return true;
      }),
  });

  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    clearErrors,
    trigger,
    reset,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: "all",
    resolver: yupResolver(errorSchema),
    defaultValues: {
      nominees: [
        {
          nameValid: "",
          mobileValid: "",
          emailValid: "",
          dobValid: "",
          nomineeRelValid: "",
          percentageValid: "",
          aadharValid: "********",
          nomAddress1: "",
          nomAddress2: "",
          pinCodeValid: "",
          cityValid: "",
          stateValid: "",
          guardianName: "",
          guardianDob: "",
          guardianRel: "",
          guardianAadhar: "********",
        },
      ],
    },
    context: { nomState },
  });

  const city = watch(`nominees[${activeIndex}].cityValid`);
  const state = watch(`nominees[${activeIndex}].stateValid`);
  const nomineePercentages = useWatch({ control, name: "nominees" }) || [];
  console.log(nomineePercentages, "nomineePercentages");


  const { fields, append, remove } = useFieldArray({
    control,
    name: "nominees",
    keyName: "id",
  });

  useEffect(() => {
    if (!nomineePercentages || nomineePercentages?.length === 0) return;

    const total = nomineePercentages?.reduce((sum, nominee) => {
      const val = parseFloat(nominee?.percentageValid);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);
    setTotalPerVal(total);
    if (total > 100) {
      toast.error("Total nominee percentage cannot exceed 100%");
    }
  }, [nomineePercentages]);

  function convertDateFormat(dateStr) {
    const [year, month, day] = dateStr?.split("-");
    return `${month}-${day}-${year}`;
  }
  function convertDate(dateStr) {
    if (!dateStr || typeof dateStr !== "string" || !dateStr.includes("/")) {
      console.warn("Invalid date format:", dateStr);
      return "";
    }
    const [day, month, year] = dateStr.split("/");
    return `${month}-${day}-${year}`;
  }

  function formatDob(dobStr) {
    if (!dobStr) return "";
    if (dobStr instanceof Date) {
      const year = dobStr.getFullYear();
      const month = String(dobStr.getMonth() + 1).padStart(2, "0");
      const day = String(dobStr.getDate()).padStart(2, "0");
      return `${month}-${day}-${year}`;
    }
    if (typeof dobStr === "string" && dobStr.includes("-")) {
      const [day, month, year] = dobStr.split("-");
      return `${month}-${day}-${year}`;

    }

    return "";
  }

  const insertNomineeDetails = async (data) => {
    setLoader(true);

    const payloadValue = {
      nominees: Array.isArray(data?.nominees)
        ? data?.nominees.map((val, index) => {

          const isSameAsAboveVal = sameAsAbove[index] || false;
          console.log(isSameAsAboveVal, "isSameAsAboveVal");

          let dobFormatted = "";
          if (val?.dobValid) {
            dobFormatted = formatDob(val?.dobValid);
          }

          let nomAge = "";
          if(dobFormatted){
            nomAge = isUnder18(dobFormatted)
          }

          console.log(dobFormatted, "dobFormatted");
          

          return {
            refId: resumeVal?.id,
            id: val?.id || 0,
            fullName: val?.nameValid,
            mobileNo:
              val?.mobileValid || resumeVal?.verificationDetails?.mobileNo,
            emailId: val?.emailValid,
            nomineeDOB: dobFormatted,
            relationshipToNominee: val?.nomineeRelValid,
            percentage: parseInt(val?.percentageValid),
            aadharNo: val?.aadharValid,
            sendPeriodicStatementViaEmail: sameAsAbove === true ? "Yes" : "No",
            nomineeAddress1: val?.nomAddress1,
            nomineeAddress2: val?.nomAddress2,
            pincode: val?.pinCodeValid,
            city: val?.cityValid,
            state: nomState[index]?.length > 0 ? nomState[index] : val?.stateValid,
            sameAsAccHolderAddress: isSameAsAboveVal,
            guardianFullName: nomAge === true ? val?.guardianName : "",
            guardianDob: nomAge === true && val?.guardianDob ? convertDateFormat(val.guardianDob) : "",
            guardianRelationship: nomAge === true ? val?.guardianRel : "",
            guardianAadharNo: nomAge === true ? val?.guardianAadhar : "",
          }
        })
        : [],
    };
    console.log(payloadValue, "payloadValue");
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axios.post(
        Lead_Creation.nominee_Details,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        resumeHandle();
        setAddNominee(true);
        toast.success(res?.data);
        setIsDetailsSaved(true);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const isUnder18 = (dobString) => {
    if (!dobString) return false;

    const dob = new Date(dobString);
    if (isNaN(dob.getTime())) return false;

    const today = new Date();
    const eighteenYearsAgo = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );

    return dob > eighteenYearsAgo;
  };

  useEffect(() => {
    if (!isDetailsSaved) return;

    isWatchingAfterSave.current = false;

    const timeout = setTimeout(() => {
      isWatchingAfterSave.current = true;
    }, 300); // allow time to stabilize after reset

    const subscription = watch(() => {
      if (isDetailsSaved && isWatchingAfterSave.current) {
        setIsFormModifiedAfterSave(true);
        setIsDetailsSaved(false); // stop watching after detecting edit
      }
    });

    return () => {
      clearTimeout(timeout);
      subscription.unsubscribe();
    };
  }, [isDetailsSaved, watch]);

  useEffect(() => {
    if (isDetailsSaved) {
      reset(getValues());
      setIsDetailsSaved(false);
    }
  }, [isDetailsSaved, reset, getValues]);  

  useEffect(() => {
    if (activeTab !== "individual") {
      reset();
    } else if (
      shouldPrefill &&
      (selectedClient?.mobile || IndiMobileNo) &&
      resumeVal?.nomineeDetails?.length > 0
    ) {
      const sameAddressFlags = resumeVal.nomineeDetails.map(
        (item) => item.sameAsAccHolderAddress === true
      );
      setSameAsAbove(sameAddressFlags);
      localStorage.setItem("nomineeAdded", "true");
      setEmptyFields(false);
      setAddNominee(true);
      setAddFlag(false);
      setEditIndex(null);
      reset({
        nominees: resumeVal?.nomineeDetails.map((item) => ({
          id: item?.id || null,
          nameValid: item.fullName || "",
          mobileValid: item?.mobileNo,
          emailValid: item?.emailId,
          nomAddress1: item?.nomineeAddress1 || "",
          nomAddress2: item?.nomineeAddress2 || "",
          pinCodeValid: item?.pincode || "",
          cityValid: item?.city || "",
          stateValid: item?.state || "",
          dobValid: item.nomineedob || "",
          nomineeRelValid: item.relationshipToNominee || "",
          percentageValid: item.percentage || "",

          aadharValid: item.aadharNo || "",
          guardianName: item?.guardianFullName || "",
          guardianDob: item?.guardiandob || "",
          guardianRel: item?.guardianRelationship || "",
          guardianAadhar: item?.guardianAadharNo || "********",
        }        

        )),
      });

    } else {
      localStorage.setItem("nomineeAdded", "false");
      setEmptyFields(true);
      setAddNominee(false);
      setEditIndex(null);
      // setSameAsAbove(false)
      setSameAsAbove(new Array(resumeVal?.nomineeDetails?.length || 0).fill(false));

    }
  }, [
    activeTab,
    shouldPrefill,
    selectedClient?.mobile,
    resumeVal?.nomineeDetails,
  ]);

  const handleEditBtn = (index) => {
    const nominee = resumeVal?.nomineeDetails[index];
    if (!nominee) return;

    setEditIndex(index);

    setValue("nominee", {
      nameValid: nominee.fullName || "",
      mobileValid: nominee.mobileNo || "",
      emailValid: nominee.emailId || "",
      dobValid: nominee.nomineedob || "",
      nomineeRelValid: nominee.relationshipToNominee || "",
      percentageValid: nominee.percentage?.toString() || "",
      aadharValid: nominee.aadharNo || "********",
      nomAddress1: nominee.nomineeAddress1 || "",
      nomAddress2: nominee.nomineeAddress2 || "",
      pinCodeValid: nominee.pincode || "",
      cityValid: nominee.city || "",
      stateValid: nominee.state || "",
      guardianName: nominee?.guardianFullName || "",
      guardianDob: nominee?.guardiandob || "",
      guardianRel: nominee?.guardianRelationship || "",
      guardianAadhar: nominee?.guardianAadharNo || "********",
    });
    // setNomState("");
    setNomState((prev) => {
      const updated = [...prev];
      updated[index] = [];
      return updated;
    });
  };

  const handlePincodeChange = (e, index) => {
    const pin = e?.target?.value;
    if (pin?.length === 6) {
      getStateCity(pin, index);
      setActiveIndex(index);
    } else {
      setValue(`nominees[${index}].cityValid`, "");
      setValue(`nominees[${index}].stateValid`, "");
      // setNomState("");
      // setCityOptions([]);
      setCityOptions((prev) => {
        const updated = [...prev];
        updated[index] = [];
        return updated;
      });
      setNomState((prev) => {
        const updated = [...prev];
        updated[index] = [];
        return updated;
      });
    }
  };

  const getStateCity = async (pincode, index) => {
    setPincodeVal(pincode);

    let payloadValue = {
      pincode: pincode,
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getRelation = await axios.post(
        Lead_Creation.pincode_Details,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        const pinResp = res?.data || [];
        // setCityOptions(pinResp);

        setCityOptions((prev) => {
          const updated = [...prev];
          updated[index] = pinResp;
          return updated;
        });
        //   setNomState((prev) => {
        //   const updated = [...prev];
        //   updated[index] = pinResp[0].state || "";
        //   return updated;
        // });

        // setPincodeVal((prev) => {
        //   const updated = [...prev];
        //   updated[index] = pincode;
        //   return updated;
        // });

        if (pinResp?.length === 1) {
          setNomState((prev) => {
            const updated = [...prev];
            updated[index] = pinResp[0]?.state || [];
            return updated;
          });
          // setNomState(pinResp[0].state);
          setValue(`nominees[${index}].cityValid`, pinResp[0]?.city);
          setValue(`nominees[${index}].stateValid`, pinResp[0].state);
        } else {
          setNomState((prev) => {
            const updated = [...prev];
            updated[index] = pinResp[0]?.state || [];
            return updated;
          });
          // setNomState(pinResp[0].state);
        }
        trigger([
          `nominees[${index}].cityValid`,
          `nominees[${index}].stateValid`,
        ]);
      } else {
        setValue(`nominees[${index}].cityValid`, "");
        setValue(`nominees[${index}].stateValid`, "");
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeIndex !== "") {
      setValue(`nominees[${activeIndex}].cityValid`, city);
      setValue(`nominees[${activeIndex}].stateValid`, state);
    }
  }, [city, state]);

  useEffect(() => {
    if (nomState?.length > 0 && activeIndex !== "") {
      trigger(`nominees[${activeIndex}].stateValid`);
    }
  }, [nomState, activeIndex]);

  useEffect(() => {
    if (cityOptions?.length > 0 && activeIndex !== "") {
      trigger(`nominees[${activeIndex}].cityValid`);
    }
  }, [cityOptions, activeIndex]);

  console.log(resumeVal,showNominee, "resumeVal");

  useEffect(() => {
  if (resumeVal?.personalDetails?.addNomineeDetails === false) {
    
    const nominees = resumeVal?.nomineeDetails || [];
    if (nominees?.length > 0) {
      const ids = nominees.map(nom => nom?.id);
      const indexes = nominees.map((_, idx) => idx);
      setNomId(ids);
      setNomIndex(indexes);
      
      deleteNomineeDetails(ids, 0);

      // nominees.forEach((nom, idx) => {
      //   deleteNomineeDetails(nom.id, idx);
      // });
    }
  }
}, [resumeVal?.personalDetails?.addNomineeDetails]);

  const deleteNomineeDetails = async (nomineeId, index) => {
    setDeleteLoader(true)
    const payloadValue = {
      refId: resumeVal?.id,
      ids: Array.isArray(nomineeId) ? nomineeId.map(String) : [String(nomineeId)],
      // id: nomineeId?.toString(),
    };
console.log(payloadValue, "deletePayload");

    let encPayload = AESEncryption(payloadValue);
    try {
      const deleteData = await axios.post(
        Lead_Creation.delete_Nominee,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(deleteData?.data);
      if (res?.status === 0) {
        setDelModal(false);
        remove(index);
        resumeHandle();
        // setSameAsAbove(false);
        setTimeout(() => {
          const remainingNominees = getValues("nominees") || [];
          const totalPercent = remainingNominees.reduce(
            (sum, nom) => sum + Number(nom.percentageValid || 0),
            0
          );
          if (totalPercent === 0) {
            setCityOptions([])
          }
          setTotalPercentage(totalPercent);
          if (remainingNominees.length === 0) {
            append({
              nameValid: "",
              mobileValid: "",
              emailValid: "",
              nomAddress1: "",
              nomAddress2: "",
              pinCodeValid: "",
              cityValid: "",
              stateValid: "",
              dobValid: "",
              nomineeRelValid: "",
              percentageValid: "",
              aadharValid: "********",
              guardianName: "",
              guardianDob: "",
              guardianRel: "",
              guardianAadhar: "********",
            });
            // setNomState("");
            setNomState((prev) => {
              const updated = [...prev];
              updated[index] = [];
              return updated;
            });
            localStorage.setItem("nomineeAdded", "false");
            setEmptyFields(true);
            setEmptyIndexes([0]);
            setAddFlag(true);
            setEditIndex(null);
          }
        }, 100);
        toast.success(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      setDeleteLoader(false)
    }
  };

  const handleDelNominee = (id, index) => {
    setNomIndex(index);
    setNomId(id);
    setDelModal(true);
  }

  const handleCloseModal = () => {
    setNomIndex(null);
    setNomId(null);
    setDelModal(false)
  }

  const finalSubmit = (data) => {
    console.log(data, "finalSubmit");
    const totalPercentage = data?.nominees.reduce(
      (sum, nominee) => sum + parseInt(nominee?.percentageValid || 0),
      0
    );

    if (totalPercentage !== 100) {
      toast.error("Total percentage of all nominees must be exactly 100%");
      return;
    }
    setIsFormModifiedAfterSave(false);

    if (
      IndiMobileNo !== null ||
      resumeVal?.verificationDetails?.mobileNo !== ""
    ) {
      justSubmitted.current = true;
      insertNomineeDetails(data);
    } else {
      toast.error("Mobile number is not there");
    }
  };

  const handleSameAddress = (index) => {
    setSameAsAbove((prevState) => {
      const updatedState = [...prevState];
      updatedState[index] = !updatedState[index];
      return updatedState;
    });
    const personal = resumeVal?.personalDetails;

    if (!sameAsAbove[index]) {
      setValue(`nominees[${index}].nomAddress1`, personal?.presentAddressLine1);
      setValue(`nominees[${index}].nomAddress2`, personal?.presentAddressLine2);
      setValue(
        `nominees[${index}].pinCodeValid`,
        personal?.presentAddressPinCode
      );
      setValue(`nominees[${index}].cityValid`, personal?.presentAddressCity);
      setValue(`nominees[${index}].stateValid`, personal?.presentAddressState);
      // setPincodeVal(personal?.presentAddressPinCode);
      setPincodeVal((prev) => {
        const updated = [...prev];
        updated[index] = personal?.presentAddressPinCode || "";
        return updated;
      });

      setCityOptions((prev) => {
        const updated = [...prev];
        updated[index] = [];
        return updated;
      });
      setNomState((prev) => {
        const updated = [...prev];
        updated[index] = [];
        return updated;
      });

      // setCityOptions([]);
      clearErrors(`nominees[${index}].nomAddress1`);
      clearErrors(`nominees[${index}].nomAddress2`);
      clearErrors(`nominees[${index}].pinCodeValid`);
      clearErrors(`nominees[${index}].cityValid`);
      clearErrors(`nominees[${index}].stateValid`);
    } else {
      setValue(`nominees[${index}].nomAddress1`, "");
      setValue(`nominees[${index}].nomAddress2`, "");
      setValue(`nominees[${index}].pinCodeValid`, "");
      setValue(`nominees[${index}].cityValid`, "");
      setValue(`nominees[${index}].stateValid`, "");
      // setNomState("");
      // setPincodeVal("");
      setNomState((prev) => {
        const updated = [...prev];
        updated[index] = [];
        return updated;
      });
      setPincodeVal((prev) => {
        const updated = [...prev];
        updated[index] = [];
        return updated;
      });
    }
    setIsFormModifiedAfterSave(true);
  };

  console.log(resumeVal?.nomineeDetails, "nomineeDetails");

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleDobInput = (e) => {
    let value = e.target.value;
    let inputVal = value.replace(/\D/g, "");
    let formattedValue = "";

    const isDeleting = value.length < prevLengthRef.current;

    if (!isDeleting) {
      if (inputVal.length <= 1) {
        formattedValue = inputVal;
      } else if (inputVal.length === 2) {
        formattedValue = inputVal + "/";
      } else if (inputVal.length === 3) {
        formattedValue = inputVal.slice(0, 2) + "/" + inputVal.slice(2);
      } else if (inputVal.length === 4) {
        formattedValue = inputVal.slice(0, 2) + "/" + inputVal.slice(2) + "/";
      } else if (inputVal.length > 4) {
        const day = inputVal.slice(0, 2);
        const month = inputVal.slice(2, 4);
        let year = inputVal.slice(4, 8);

        if (day && month && year.length === 4) {
          const enteredDate = new Date(`${year}-${month}-${day}`);
          const todayDate = new Date(DateReverse);
          todayDate.setHours(0, 0, 0, 0);
          if (enteredDate > todayDate) {
            // Future → use today's date
            formattedValue = FormatedDate;
          } else {
            formattedValue = `${day}/${month}/${year}`;
          }
        } else {
          formattedValue = `${day}/${month}/${year}`;
        }
      }
    } else {
      // On delete, format more loosely
      if (inputVal.length <= 2) {
        formattedValue = inputVal;
      } else if (inputVal.length <= 4) {
        formattedValue = inputVal.slice(0, 2) + "/" + inputVal.slice(2);
      } else {
        const day = inputVal.slice(0, 2);
        const month = inputVal.slice(2, 4);
        let year = inputVal.slice(4, 8);
        formattedValue = `${day}/${month}/${year}`;
      }
    }

    prevLengthRef.current = formattedValue.length;

    e.target.value = formattedValue.slice(0, 10);
  };

  const handleAadhaarInput = (fieldName) => (e) => {
    let value = e.target.value;

    if (!value.startsWith("********")) {
      value = "********";
    }

    const numericPart = value.replace(/\D/g, "").slice(-4);
    const fullValue = `********${numericPart}`;
    e.target.value = fullValue;

    setValue(fieldName, fullValue, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleKeyDown = (e) => {
    const cursorPos = e.target.selectionStart;

    if (
      (e.key === "ArrowLeft" && cursorPos <= 8) ||
      (e.key === "Backspace" && cursorPos <= 8) ||
      (e.key.length === 1 && cursorPos < 8)
    ) {
      e.preventDefault();
      e.target.setSelectionRange(8, 8);
    }
  };

  const addNomineeBtn = () => {
    setAddFlag(true);
    const nominees = watch("nominees") || [];
    // setSameAsAbove(false);

    const hasEmptyNominee = nominees.some((nom) => {
      const isMinor = isUnder18(nom?.dobValid);
      const requiredFields = [
        nom?.nameValid,
        nom?.dobValid,
        nom?.percentageValid,
        nom?.aadharValid,
        nom?.cityValid,
        nom?.emailValid,
        nom?.mobileValid,
        nom?.nomAddress1,
        // nom?.nomAddress2,
        nom?.nomineeRelValid,
        nom?.pinCodeValid,
        nom?.stateValid || nomState,

        ...(isMinor
          ? [
            nom?.guardianName,
            nom?.guardianDob,
            nom?.guardianRel,
            nom?.guardianAadhar,
          ]
          : []),
      ];
      return requiredFields.some((val) => !val || val === "********");
    });

    const nomineeCount = nominees?.length;
    if (totalPercentage >= 100) {
      toast.error("Total percentage has reached 100");
      return;
    }

    if (nomineeCount >= 3) {
      toast.error("You can only add up to 3 nominees");
      return;
    }

    if (hasEmptyNominee) {
      toast.error(
        "Please fill the existing empty nominee before adding a new one"
      );
      return;
    }
    if (totalPerVal < 100) {
      const newIndex = nominees.length;
      setIsFormModifiedAfterSave(true)

      setEmptyFields(true);
      append({
        nameValid: "",
        mobileValid: "",
        emailValid: "",
        nomAddress1: "",
        nomAddress2: "",
        pinCodeValid: "",
        cityValid: "",
        stateValid: "",
        dobValid: "",
        nomineeRelValid: "",
        percentageValid: "",
        aadharValid: "********",
        guardianName: "",
        guardianDob: "",
        guardianRel: "",
        guardianAadhar: "********",
      });
      // setNomState([]);
      // setNomState((prev) => {
      //   const updated = [...prev];
      //   updated[index] = [];
      //   return updated;
      // });
      setEmptyIndexes((prev) => [...prev, newIndex]);
    } else {
      toast.error("You can add only up to 3 nominees");
    }
  };

  const handleFocus = (e) => {
    const value = e.target.value;
    const digits = value.slice(8);

    if (value === "********" || (/^\*{8}$/.test(value) && digits === "")) {
      e.target.value = "********";
      e.target.setSelectionRange(8, 8);
    } else {
      e.target.setSelectionRange(value.length, value.length);
    }
  };

  const handlePasteInput = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText.toUpperCase().replace(/[^A-Z\s]/g, "");
    clean = clean.replace(/\s+/g, " ").trim();
    if (clean === "") return;
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const currentValue = input.value;
    const newValue = (
      currentValue.slice(0, start) +
      clean +
      currentValue.slice(end)
    ).slice(0, 40);
    setValue(fieldName, newValue, { shouldValidate: true });
    input.value = newValue;
    const cursorPos = start + clean.length;
    setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
  };

  const handlePaste = (fieldName) => (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text");
    const onlyNumbers = pastedData.replace(/\D/g, "").slice(0, 10);
    if (onlyNumbers === "") return;
    setValue(fieldName, onlyNumbers, { shouldValidate: true });
  };

  const handlePasteEmail = (fieldName) => (e) => {
    e.preventDefault();
    let pastedText = e.clipboardData.getData("text");
    let clean = pastedText.replace(/[^a-zA-Z0-9@.]/g, "");
    const atIndex = clean.indexOf("@");
    if (atIndex !== -1) {
      const beforeAt = clean.slice(0, atIndex + 1);
      const afterAt = clean.slice(atIndex + 1).replace(/@/g, "");
      clean = beforeAt + afterAt;
    }
    clean = clean.replace(/\.{2,}/g, ".");
    clean = clean.replace(/\.@/g, "@");
    clean = clean.replace(/^[@.]+|[@.]+$/g, "");

    setValue(fieldName, clean, { shouldValidate: true });
  };

  const handlePastePincode = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText.replace(/\D/g, "").trim().slice(0, 6);
    if (clean === "") return;
    setValue(fieldName, clean, { shouldValidate: true });
    e.target.value = clean;
  };

  const handlePastePercent = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const clean = pastedText.replace(/\D/g, "").slice(0, 3).trim();
    if (clean === "") return;
    e.target.value = clean;
    setValue(fieldName, clean, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handlePasteAddress = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText
      .toUpperCase()
      .replace(/[^A-Z0-9#\/\-&.,\s]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/, "")
      .slice(0, 50);
    if (clean === "") return;
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const currentValue = input.value;
    const newValue = (
      currentValue.slice(0, start) +
      clean +
      currentValue.slice(end)
    ).slice(0, 50);
    setValue(fieldName, newValue, { shouldValidate: true });
    input.value = newValue;
    const cursorPos = Math.min(start + clean.length, 50);
    setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
  };

  const handlePasteAadhaar = (fieldName) => (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text");
    const digitsOnly = pasteData.replace(/\D/g, "").slice(0, 4);

    if (digitsOnly.length > 0) {
      const existingValue = getValues(fieldName) || "********";
      const newValue = existingValue.slice(0, 8) + digitsOnly;

      setValue(fieldName, newValue, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  const dynamicTotalPercentage = nomineePercentages?.reduce(
    (sum, nom) => sum + Number(nom?.percentageValid || 0),
    0
  );

  const isAddDisabled = useMemo(() => {
    const nomineeCount = nomineePercentages?.length || 0;

    const hasEmptyNominee = nomineePercentages?.some((nom) => {
      const isMinor = isUnder18(nom?.dobValid);
      const requiredFields = [
        nom?.nameValid,
        nom?.dobValid,
        nom?.percentageValid,
        nom?.aadharValid,
        nom?.cityValid,
        nom?.emailValid,
        nom?.mobileValid,
        nom?.nomAddress1,
        nom?.nomineeRelValid,
        nom?.pinCodeValid,
        nom?.stateValid || nomState,
        ...(isMinor
          ? [
            nom?.guardianName,
            nom?.guardianDob,
            nom?.guardianRel,
            nom?.guardianAadhar,
          ]
          : []),
      ];
      return requiredFields.some((val) => !val || val === "********");
    });

    return (
      dynamicTotalPercentage >= 100 || nomineeCount >= 3 || hasEmptyNominee
    );
  }, [nomineePercentages, nomState]);

  const handleEmailInput = (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9@.]/g, "");

    if (/^[@.]/.test(value)) {
      value = value.substring(1);
    }
    const atParts = value.split("@");
    if (atParts.length > 2) {
      value = atParts[0] + "@" + atParts.slice(1).join("").replace(/@/g, "");
    }
    value = value.replace(/\.{2,}/g, ".");
    value = value.replace(/\.@/, "@");
    value = value.replace(/@\.{1}/, "@");
    value = value.slice(0, 35);
    e.target.value = value;
    setValue("emailValid", value, { shouldValidate: true });
  };

  console.log(addNominee, resumeVal?.nomineeDetails, "addNominee");
  


  return (
    <>
      <div className="row border-parent accordian-section-wrapper">
        <form
          className="individual-form nominee-form"
          onSubmit={handleSubmit(finalSubmit)}
        >
          {addNominee && (
            <>
              {resumeVal?.nomineeDetails?.length > 0 &&
                resumeVal?.nomineeDetails.map((item, index) => (
                  <div className="nominee-card-wrapper">
                    <ul className="nominee-ul">
                      <li>
                        <p className="nominee-header">Nominee {index + 1}</p>
                        <p className="nominee-body">{item?.fullName}</p>
                      </li>

                      <li>
                        <p className="nominee-header">Relationship to Nominee</p>
                        <p className="nominee-body">
                          {item?.relationshipToNominee}
                        </p>
                      </li>

                      <li>
                        <p className="nominee-header">Nominee Share (%)</p>
                        <p className="nominee-body">{item?.percentage}%</p>
                      </li>

                      <li className="wrap-nomineebtn">
                        <>
                          <div className="editbtn" onClick={() => handleEditBtn(index)}>
                            <button
                              type="button"
                              className="validate-btn"
                            // onClick={() => handleEditBtn(index)}
                            >
                              Edit
                            </button>
                          </div>
                          {fields?.length > 0 && (
                            deleteLoader ?
                              <SmallLoader />
                              :
                              <div className="delete-btn"
                                onClick={() => handleDelNominee(item?.id, index)}
                              >
                                <button
                                  type="button"
                                  className="validate-btn"
                                // onClick={() =>
                                //   deleteNomineeDetails(item?.id, index)
                                // }
                                >
                                  Delete
                                </button>
                              </div>
                          )}
                        </>
                      </li>
                    </ul>
                  </div>
                ))}
            </>
          )}

          {fields.map((field, index) => {
            const nomineeDob = watch(`nominees[${index}].dobValid`);
            const showGuardianFields = isUnder18(nomineeDob);
            console.log(nomineeDob, showGuardianFields, "nomineeDob");

            const showFields =
              editIndex === index ||
              (localStorage.getItem("nomineeAdded") === "false" && emptyFields) ||
              (addFlag && emptyIndexes.includes(index));

            return (
              showFields && (
                <>
                  <div
                    className="row border-parent accordian-section-wrapper input-fields"
                    key={field?.id}
                  >
                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      <CommonInput
                        label="Full Name"
                        name={`nominees[${index}].nameValid`}
                        placeholder="Enter nominee name"
                        required
                        max={40}
                        register={register}
                        onKeyPress={(e) => {
                          if (!/^[A-Za-z\s]$/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const start = e.target.selectionStart;
                          const end = e.target.selectionEnd;
                          let input = e.target.value;
                          input = input
                            .toUpperCase()
                            .replace(/[^A-Z\s]/g, "")
                            .replace(/\s+/g, " ")
                            .trimStart()
                            .slice(0, 40);

                          e.target.value = input;

                          e.target.setSelectionRange(start, end);

                          // if (input.trim() === "") {
                          //   setValue(`nominees[${index}].nameValid`, "", {
                          //     shouldValidate: true,
                          //   });
                          //   return;
                          // }

                          // setValue(`nominees[${index}].nameValid`, input, {
                          //   shouldValidate: true,
                          // });
                        }}
                        onPaste={handlePasteInput(`nominees[${index}].nameValid`)}
                      />
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.nameValid?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      <CommonInput
                        label="Mobile Number"
                        name={`nominees[${index}].mobileValid`}
                        max={10}
                        pattern="[0-9]*"
                        placeholder="Enter mobile number"
                        required
                        register={register}
                        onKeyPress={(e) => mobileVal(e)}
                        onPaste={handlePaste(`nominees[${index}].mobileValid`)}
                      />
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.mobileValid?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      <CommonInput
                        label="Email id"
                        name={`nominees[${index}].emailValid`}
                        placeholder="Enter email address"
                        required
                        max={35}
                        register={register}
                        onKeyPress={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                        onPaste={handlePasteEmail(
                          `nominees[${index}].emailValid`
                        )}
                        onInput={(e) => handleEmailInput(e)}
                      // value={resumeVal?.nomineeDetails?.nameValid}
                      />
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.emailValid?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      {/* <CommonInput
                      label="Nominee Date of Birth"
                      name={`nominees[${index}].dobValid`}
                      placeholder="DD/MM/YYYY"
                      required
                      register={register}
                      max={DateReverse}
                      onInput={handleDobInput}
                      value={splitDateNewSlash(resumeVal?.dob)}
                    /> */}
                      <div className="form-group">
                        <label className="form-label">Nominee Date of Birth
                          <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                        </label>
                        <input
                          type="date"
                          className="datepicker form-control text-uppercase"
                          id="FromDateApPayout"
                          placeholder="DD-MM-YYYY"
                          {...register(`nominees[${index}].dobValid`)}
                          max={DateReverse}

                        />
                        <p className="forget-link add-error">
                          <span>
                            {errors?.nominees?.[index]?.dobValid?.message}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation individiual-select">
                      <CommonSelect
                        label="Relationship to Nominee"
                        name={`nominees[${index}].nomineeRelValid`}
                        options={relation}
                        required
                        register={register}
                        value={getValues(`nominees[${index}].nomineeRelValid`)}

                      />
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.nomineeRelValid?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      <CommonInput
                        label="Enter Aadhaar Card Number (Last 4 digits)"
                        name={`nominees[${index}].aadharValid`}
                        placeholder="Enter Aadhar Card Number"
                        required
                        register={register}
                        onInput={handleAadhaarInput(
                          `nominees[${index}].aadharValid`
                        )}
                        onKeyDown={handleKeyDown}
                        max={12}
                        onFocus={handleFocus}
                        onPaste={handlePasteAadhaar(
                          `nominees[${index}].aadharValid`
                        )}
                      />
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.aadharValid?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      <CommonInput
                        label="Nominee Address Line 1"
                        name={`nominees[${index}].nomAddress1` || "nomAddress1"}
                        placeholder="Enter nominee address line 1"
                        required
                        max={50}
                        register={register}
                        disable={sameAsAbove[index]}
                        onPaste={handlePasteAddress(
                          `nominees[${index}].nomAddress1`
                        )}
                        onChange={(e) => {
                          const start = e.target.selectionStart;
                          const end = e.target.selectionEnd;

                          let input = e.target.value.toUpperCase();
                          input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                          input = input.replace(/\s{2,}/g, " ");
                          input = input.replace(/^\s+/, "");
                          if (input.length > 50) input = input.slice(0, 50);

                          e.target.value = input;
                          e.target.setSelectionRange(start, end);
                          // setValue(`nominees[${index}].nomAddress1`, input, {
                          //   shouldValidate: true,
                          // });
                        }}
                      />
                      <span className="gray-text" style={{ color: "#9E9E9E" }}>
                        <div className="wrap-checkbox">
                          <input
                            className="input-checkbox"
                            type="checkbox"
                            checked={
                              sameAsAbove[index]
                            }
                            onChange={() => handleSameAddress(index)}
                          />
                          Same as account holder's address
                        </div>
                      </span>
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.nomAddress1?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      <CommonInput
                        label="Nominee Address Line 2"
                        name={`nominees[${index}].nomAddress2`}
                        placeholder="Enter nominee address line 2"
                        // onPaste={(e) => {
                        //   e.preventDefault();
                        //   return false;
                        // }}
                        max={50}
                        register={register}
                        disable={sameAsAbove[index]}
                        onPaste={handlePasteAddress(
                          `nominees[${index}].nomAddress2`
                        )}
                        onChange={(e) => {
                          const start = e.target.selectionStart;
                          const end = e.target.selectionEnd;
                          let input = e.target.value.toUpperCase();
                          input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                          input = input.replace(/\s{2,}/g, " ");
                          input = input.replace(/^\s+/, "");
                          if (input.length > 50) input = input.slice(0, 50);

                          e.target.value = input;
                          e.target.setSelectionRange(start, end);
                          // setValue(`nominees[${index}].nomAddress2`, input, {
                          //   shouldValidate: true,
                          // });
                        }}
                      />
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.nomAddress2?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      <CommonInput
                        label="Pincode"
                        name={`nominees[${index}].pinCodeValid`}
                        placeholder="Enter pincode"
                        required
                        max={6}
                        onPaste={handlePastePincode("pinCodeValid")}
                        register={register}
                        onChange={(e) => handlePincodeChange(e, index)}
                        onInput={onlyNumber}
                        value={
                          pincodeVal[index]?.length === 6
                            ? pincodeVal[index]
                            : getValues(`nominees[${index}].pinCodeValid`)
                        }
                        disable={sameAsAbove[index]}
                      />
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.pinCodeValid?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian individiual-select lead-creation">
                      <CommonSelect
                        label="City"
                        name={`nominees[${index}].cityValid`}
                        required
                        register={register}
                        
                        options={(() => {
                          const currentCity = getValues(`nominees[${index}].cityValid`);
                          const optionsForIndex = cityOptions[index] || [];
                          const uniqueOptions = new Map();

                          if (currentCity) {
                            uniqueOptions.set(currentCity, { name: currentCity });
                          }

                          optionsForIndex.forEach((city) => {
                            if (city?.city) {
                              uniqueOptions.set(city.city, { name: city.city });
                            }
                          });

                          return Array.from(uniqueOptions.values());
                        })()}
                        onChange={(e) => {
                          const selected = e.target.value;
                          setValue(`nominees[${index}].cityValid`, selected, {
                            shouldValidate: true,
                          });
                        }}

                        value={getValues(`nominees[${index}].cityValid`)}

                        getValues={(sameAsAbove[index] && cityOptions[index]?.length === 0) ?
                          getValues(`nominees[${index}].cityValid`) :
                          ""}
                      />
                      {console.log(sameAsAbove[index],
                        getValues(`nominees[${index}].cityValid`),
                        cityOptions[index], "cityOptions")}

                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.cityValid?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian individiual-select lead-creation">
                      <CommonSelect
                        label="State"
                        name={`nominees[${index}].stateValid`}
                        required
                        register={register}
                        // options={[{
                        //   name: nomState[index]?.length > 0
                        //     ? nomState[index]
                        //     : getValues(`nominees[${index}].stateValid`)
                        // }]}
                        options={[{
                          name:
                            nomState[index]?.length > 0
                              ? nomState[index]
                              : getValues(`nominees[${index}].stateValid`)

                        }]}

                        value={nomState[index]?.length > 0
                          ? nomState[index]
                          : getValues(`nominees[${index}].stateValid`)
                        }

                        getValues={
                          nomState[index]?.length > 0
                            ? nomState[index]
                            : getValues(`nominees[${index}].stateValid`)
                        }
                      // value={
                      //   nomState?.length > 0
                      //     ? nomState
                      //     : getValues(`nominees[${index}].stateValid`)
                      // }
                      />
                      {console.log(nomState[index],
                        getValues(`nominees[${index}].stateValid`),
                        "stateValid")
                      }
                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.stateValid?.message}
                        </span>
                      </p>
                    </div>

                    <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                      <CommonInput
                        label="Percentage"
                        name={`nominees[${index}].percentageValid`}
                        placeholder="Enter percentage"
                        required
                        register={register}
                        onInput={onlyNumber}
                        max={3}
                        onPaste={handlePastePercent(
                          `nominees[${index}].percentageValid`
                        )}
                      />
                      <span className="gray-text" style={{ color: "#9E9E9E" }}>
                        Note: Total percentage should be equal to 100%
                      </span>

                      <p className="forget-link add-error">
                        <span>
                          {errors?.nominees?.[index]?.percentageValid?.message ||
                            errors.nominees?.message}
                        </span>
                      </p>
                    </div>
                  </div>
                  {showGuardianFields && (
                    <div className="bold-title">
                      Guardian Details
                      <span className="guard-span">
                        {" "}
                        (Since the nominee is below 18 years of age, you will need
                        to add guardian details)
                      </span>
                      <div className="row border-parent accordian-section-wrapper input-fields">
                        <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                          <CommonInput
                            label="Guardian Full Name"
                            name={`nominees[${index}].guardianName`}
                            placeholder="Enter guardian name"
                            required
                            register={register}
                            onKeyPress={(e) => {
                              if (!/^[A-Za-z\s]$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              let input = e.target.value;
                              input = input
                                .toUpperCase()
                                .replace(/[^A-Z\s]/g, "")
                                .replace(/\s+/g, " ")
                                .trimStart();

                              if (input.trim() === "") {
                                setValue(`nominees[${index}].guardianName`, "", {
                                  shouldValidate: true,
                                });
                                return;
                              }

                              setValue(`nominees[${index}].guardianName`, input, {
                                shouldValidate: true,
                              });
                            }}
                            max={40}
                            onPaste={handlePasteInput(
                              `nominees[${index}].guardianName`
                            )}
                          />
                          <p className="forget-link add-error">
                            <span>
                              {errors?.nominees?.[index]?.guardianName?.message}
                            </span>
                          </p>
                        </div>

                        <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                          {/* <CommonInput
                            label="Guardian Date of Birth"
                            name={`nominees[${index}].guardianDob`}
                            placeholder="DD/MM/YYYY"
                            required
                            register={register}
                            max={DateReverse}
                            onInput={handleDobInput}
                            value={splitDateNewSlash(resumeVal?.dob)}
                          /> */}

                          <div className="form-group">
                            <label className="form-label">Guardian Date of Birth
                              <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                            </label>
                            <input
                              type="date"
                              className="datepicker form-control text-uppercase"
                              id="FromDateApPayout"
                              placeholder="DD-MM-YYYY"
                              {...register(`nominees[${index}].guardianDob`)}
                              max={DateReverse}

                            />
                          </div>
                          <p className="forget-link add-error">
                            <span>
                              {errors?.nominees?.[index]?.guardianDob?.message}
                            </span>
                          </p>
                        </div>

                        <div className="col-sm-6 col-lg-4 card-accordian lead-creation individiual-select">
                          <CommonSelect
                            label="Relationship to Nominee"
                            name={`nominees[${index}].guardianRel`}
                            options={relation}
                            required
                            register={register}
                             value={getValues(`nominees[${index}].guardianRel`)}
                          />
                          <p className="forget-link add-error">
                            <span>
                              {errors?.nominees?.[index]?.guardianRel?.message}
                            </span>
                          </p>
                        </div>

                        <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
                          <CommonInput
                            label="Enter Aadhaar Card Number (Last 4 digits)"
                            name={`nominees[${index}].guardianAadhar`}
                            placeholder="Enter Aadhar Card Number"
                            required
                            register={register}
                            onKeyDown={handleKeyDown}
                            max={12}
                            onPaste={handlePasteAadhaar(
                              `nominees[${index}].guardianAadhar`
                            )}
                            onFocus={handleFocus}
                            onInput={handleAadhaarInput(
                              `nominees[${index}].guardianAadhar`
                            )}
                          />
                          <p className="forget-link add-error">
                            <span>
                              {errors?.nominees?.[index]?.guardianAadhar?.message}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )
            );
          })}

          <div className="nominee-btn-wrapper nominee-wrap-sec">
            <div
              className="wrap-button"
            >
              <button
                type="button"
                className={`val-btn-nom ${isAddDisabled ? "disable-nom-btn" : ""
                  }`}
                disabled={isAddDisabled}
                onClick={addNomineeBtn}
              >
                Add Another Nominee
              </button>
            </div>
            {totalPercentage < 100 && (
              <div className="wrap-button">
                <button
                  type="submit"
                  className="val-btn-wrap"
                  
                >
                  {loader ? (
                    <SmallLoader />
                  ) : editIndex !== null ? (
                    <>Continue</>
                  ) : (
                    <>Save</>
                  )}
                </button>
              </div>
            )}
          </div>
        </form>
      </div>

      <Modal
        show={delModal}
        onHide={handleCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model ifsc-Modal bank-verify-modal individual-modal final-modal"
        backdrop="static"
        keyboard={false}
      >
        <button
          type="button"
          className="btn-close ifsc-modal-btn"
          aria-label="Close"
          onClick={handleCloseModal}
        >
          <span className="icon-close"></span>
        </button>
        <Modal.Header className="modal-header ifsc-modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <span>
              <img src={questionImg} alt="questionIcon" />
            </span>
            <p className="final-modal-title">Are you sure you want to delete nominee details?</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="nominee-btn-wrapper nominee-wrap-sec nom-btns">
            <div
            className="wrap-button"
             
          >
            <button
              type="button"
              className="val-btn-nom cancel-btn"
              onClick={handleCloseModal}
             
            >
              Cancel
            </button>
            </div>
            <div className="wrap-button">
              <button type="submit" className="val-btn-wrap"
                onClick={() => deleteNomineeDetails(nomId, nomIndex)}>
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NomineeDetails;
